import { useState } from 'react'

const navItems = [
  { href: '#home', label: 'トップ' },
  { href: '#products', label: '商品紹介' },
  { href: '#blog-instagram', label: '新着情報' },
  { href: '#concept', label: 'コンセプト' },
  { href: '#access', label: 'アクセス' },
]

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen)
  const closeMenu = () => setIsMenuOpen(false)

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-center">
          <img
            src="/assets/img/kamando_logo_alpha.png"
            alt="諫早パン工房Kamando"
            className="header-logo"
          />
        </div>

        <button
          className={`hamburger ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="メニュー"
          aria-expanded={isMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav-center ${isMenuOpen ? 'active' : ''}`}>
          <ul className="nav-list">
            {navItems.map((item) => (
              <li key={item.href}>
                <a href={item.href} onClick={closeMenu}>
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  )
}
